<template>
  <section class="QuizThumbsUpDownResponse ContentSection">
    <h5 v-html="properties.title"></h5>
    <div class="QuizThumbsUpDownResponse__quiz" v-if="!quizComplete">
      <transition-group :name="animations[direction].name">
        <article class="QuizThumbsUpDownResponse__quiz__slide"
          :class="{ 'QuizThumbsUpDownResponse__quiz__slide--flipped': slide.answer !== false }"
          v-for="slide in quizSlideshow" :key="slide.id">
          <div class="front" :style="{ 'background-color': properties.slidesColor }" v-html="slide.text">
          </div>
          <div class="back" v-html="slide.answer" @click="linkTracking">
          </div>
        </article>
      </transition-group>

      <div class="QuizThumbsUpDownResponse__quiz__navigation"
        :class="{ 'QuizThumbsUpDownResponse__quiz__navigation--flipped': aSlideCurrentlyFlipped }">
        <button
          class="QuizThumbsUpDownResponse__quiz__navigation__button QuizThumbsUpDownResponse__quiz__navigation__button_down"
          @click="answerQuiz('down')">
          <img src="@/assets/img/ui/thumb.svg" />
        </button>
        <span v-html="quizProgress"></span>
        <button
          class="QuizThumbsUpDownResponse__quiz__navigation__button QuizThumbsUpDownResponse__quiz__navigation__button_up"
          @click="answerQuiz('up')">
          <img src="@/assets/img/ui/thumb.svg" />
        </button>
        <button class="QuizThumbsUpDownResponse__quiz__navigation__button_next"
          :style="{ 'background-color': properties.slidesColor }" @click="nextSlide">
          Næste
        </button>
      </div>
    </div>

    <div id="QuizThumbsUpDownResponse__results" ref="results" v-else>
      <div v-for="slide in slides" :key="slide.id" :class="getResultThumbClass(slide)">
        <div :style="{ 'border-color': properties.slidesColor }">
          <span v-html="slide.text"></span>
        </div>
        <div>
          <span v-html="slide.answer" @click="linkTracking"></span>
        </div>
      </div>



    </div>

    <div id="QuizThumbsUpDownResponse__results_PDF" v-if="quizComplete">
      <p class="double-space">Hent som pdf</p>

      <PDFGenerator :headerTitle="'Hvilken type uddannelse passer bedst til mig?'" :color="pageData.color"
        :buttonText="'DOWNLOAD'" :PDFName="properties.title">

        <h3 class="pdf__element pdf__subtitle">{{ properties.title }}</h3>

        <template v-for="(slide, i) in slides" :key="slide.id">
          <div class="pdf__element pdf__updowncol" :class="getResultThumbClass(slide)">
            <div :style="{ 'border-color': properties.slidesColor }">
              <span v-html="slide.text"></span>
            </div>
            <div>
              <span v-html="slide.answer"></span>

            </div>

          </div>
          <!-- page break hver 3 svar, men kun 2 på første side -->
          <div v-if="i % 3 == 1" class="html2pdf__page-break"></div>
        </template>

      </PDFGenerator>

    </div>




    <!-- <PDFGenerator v-if="quizComplete" :buttonText="'Download dine svar'" :PDFName="properties.title" :html="resultsHTML"></PDFGenerator> -->
  </section>
</template>
<script>
import PDFGenerator from '../util/PDFGenerator.vue';

export default {
  props: ["properties", "pageData"],
  components: {
    PDFGenerator
  },
  data() {
    return {
      activeSlide: 0,
      slides: [],
      quizComplete: false,
      aSlideCurrentlyFlipped: false,

      resultsHTML: null,

      direction: "up",
      animations: {
        down: {
          name: "fadeOutLeft",
        },
        up: {
          name: "fadeOutRight",
        },
        skip: {
          name: "fadeOutUp",
        },
      },
    };
  },
  created() {
    this.slides = this.properties.slides.map((slide, i) => {
      slide.id = `slide__${i}`;
      slide.answer = false;
      return slide;
    });
  },
  mounted() { },
  methods: {
    answerQuiz(thumb) {
      this.direction = thumb;


      switch (thumb) {
        case "up":
          this.slides[this.activeSlide].answer = this.slides[this.activeSlide].responseUp;
          break;

        case "down":
          this.slides[this.activeSlide].answer = this.slides[this.activeSlide].responseDown;
          break;

        case "skip":
          break;
      }

      if(this.activeSlide === 0) 
        _paq.push(["trackEvent", "quiz", "quiz-started", window.app.vm.$route.path]);


      if (this.slides[this.activeSlide].answer === false) {
        if (this.activeSlide == this.slides.length - 1) {
          this.endQuiz();
          return;
        }

        this.activeSlide++;
      }
    },
    nextSlide() {
      if (this.activeSlide == this.slides.length - 1) {
        this.endQuiz();
        return;
      }
      this.activeSlide++;
    },
    endQuiz() {
      this.quizComplete = true;
      
      _paq.push(["trackEvent", "quiz", "quiz-ended", window.app.vm.$route.path]);

      setTimeout(() => {
        this.getHTML();
      }, 1);
    },



    getResultThumbClass(slide) {
      let classname = "QuizThumbsUpDownResponse__results_result";
      let suffix = '';

      if (slide.answer == slide.responseUp) {
        suffix = '--thumbsup'
      } else if (slide.answer == slide.responseDown) {
        suffix = '--thumbsdown'
      }

      return classname + suffix
    },
    getHTML() {
      this.resultsHTML = document.getElementById('app');
    },
    linkTracking(event) {
      // Check if the clicked element is a hyperlink
      if (event.target.tagName === "A") {
        // Handle the hyperlink click event
        const url = event.target.getAttribute("href");
        // You can do something with the href, for example, open it in a new tab
        _paq.push(["trackEvent", "external-link", window.app.vm.$route.path, url]);
      }
    }
  },
  computed: {
    quizSlideshow() {
      let slides = [];
      this.aSlideCurrentlyFlipped = this.slides[this.activeSlide].answer !== false;
      slides.push(this.slides[this.activeSlide]);
      return slides;
    },
    quizProgress() {
      let currentSlide = (this.activeSlide + 1).toString();
      let addPadding = currentSlide.length < 2 && this.slides.length >= 10;

      return `${addPadding ? "0" + currentSlide : currentSlide} | ${this.slides.length
        }`;
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/sass/_responsiveness.scss";

.QuizThumbsUpDownResponse {
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  padding-top: 120px;
  padding-bottom: 160px;
  background: var(--light-grey);

  h5 {
    text-align: left;
    margin-bottom: 40px;
  }

  &>div {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: var(--content-max-width);

    &.QuizThumbsUpDownResponse__quiz {
      position: relative;
      -webkit-perspective: 2000px;
      perspective: 2000px;
      height: 280px;
      padding: var(--content-padding);

      .QuizThumbsUpDownResponse__quiz__slide {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 70px);
        max-width: 580px;
        height: 100%;
        box-shadow: var(--shadow-small);


        -webkit-transform-style: preserve-3d !important;
        transform-style: preserve-3d;
        -webkit-transition: all .5s var(--tk-easeinout);
        transition: all .5s var(--tk-easeinout);

        &>div {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          transition: all .5s var(--tk-easeinout);
          padding: 10px 40px;
          

          &.front {
            color: #fff;
            -webkit-backface-visibility: hidden !important;
            backface-visibility: hidden;
          }

          &.back {
            overflow: hidden;
            z-index: -1;
            -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
            opacity: 1;
            box-sizing: border-box;
            background-color: #fff;
            flex-direction: column;
          }
        }

        &--flipped {
          -webkit-transform: rotateY(180deg);
          transform: rotateY(180deg);

          .front {
            box-shadow: 0 0 0 #aaa;
            opacity: 0; // iphone hack
          }

          .back {
            box-shadow: 5px 5px 5px #aaa;
          }
        }

        .front,
        .back {
          &>p {
            font-size: 20px;
            line-height: 26px;
            font-weight: bold;

          }
        }

        @include mobile-only {
          
          .front,
        .back {
          padding: 10px;
        }
          .back {
            &>p {
              font-size: 18px;
              line-height: 22px;
              font-weight: bold;

            }
          }
        }

        button {
          position: absolute;
          right: 20px;
          bottom: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;

          &>img {
            margin-left: 14px;
          }
        }

        &.fadeOutLeft-enter-from {
          transform: translateX(200px);
          z-index: 10;
        }

        &.fadeOutRight-leave-to {
          transform: translateX(200px) rotate(12deg) translateY(20px) rotateY(180deg);
        }

        &.fadeOutRight-enter-from {
          transform: translateX(-200px);
          z-index: 10;
        }

        &.fadeOutLeft-leave-to {
          transform: translateX(-200px) rotate(-12deg) translateY(20px) rotateY(180deg);
        }
      }

      .QuizThumbsUpDownResponse__quiz__navigation {
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 480px;
        height: 72px;
        max-width: 100vw;
        padding: var(--content-padding);

        top: calc(100% + 14px);

        &>span {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-size: 20px;
          font-weight: bold;
        }

        .QuizThumbsUpDownResponse__quiz__navigation__button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 72px;
          height: 72px;
          border-radius: 100%;
          background: #fff;
          box-shadow: var(--shadow-small);
          transition: ease 0.15s;
          transition-property: transform opacity;
          opacity: 1;
          cursor: pointer;

          &:hover {
            transform: scale(1.05);
          }

          &_down {
            img {
              transform: rotate(180deg);
              margin-bottom: -6px;
            }
          }

          &_up {
            img {
              margin-top: -3px;
            }
          }
        }

        .QuizThumbsUpDownResponse__quiz__navigation__button_next {
          position: absolute;
          cursor: pointer;
          width: 185px;
          height: 60px;
          font-size: 22px;
          border-radius: 1000px;
          color: #fff;
          font-weight: bold;
          right: 0;
          opacity: 0;
          pointer-events: none;
          transition: ease 0.15s;
          transition-property: transform opacity;
        }

        &--flipped {
          .QuizThumbsUpDownResponse__quiz__navigation__button {
            pointer-events: none;
            opacity: 0;
          }

          .QuizThumbsUpDownResponse__quiz__navigation__button_next {
            opacity: 1;
            pointer-events: all;
          }
        }
      }
    }

    &#QuizThumbsUpDownResponse__results {
      flex-wrap: wrap;
      padding: var(--content-padding);
      padding-top: 55px;

      &>div {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        text-align: left;

        &>div {
          position: relative;
          width: 48%;
          border-top: solid 4px;
          padding-top: 16px;
          padding-bottom: 90px;




          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: calc(100% + 16px);
            width: 32px;
            height: 32px;
            background-position: center;
            background-size: 100%;
            background-repeat: no-repeat;
          }

          &:first-of-type {
            font-weight: bold;

            &::after {
              background-image: url(@/assets/img/ui/question-circle-pdf.svg);
            }
          }

          &:last-of-type {
            border-color: #000;

            &::after {
              background-image: url(@/assets/img/ui/thumb.svg);
            }
          }
        }

        &.QuizThumbsUpDownResponse__results_result--thumbsdown {
          &>div {

            &:last-of-type {
              &::after {
                transform: scaleY(-1);
              }
            }
          }
        }
      }
    }

    &#QuizThumbsUpDownResponse__results_PDF {
      position: relative;
      display: block;
      text-align: left;

      p {
        margin: 1em 0;

        &.double-space {
          margin: 2em 0 1em;
          ;
        }
      }
    }



  }

  @include mobile-only {
    padding-bottom: 190px;

    .QuizThumbsUpDownResponse__quiz__navigation__button_next {
      right: auto;
      left: 50%;
      transform: translateX(-50%);
      top: 100%;
    }

    #QuizThumbsUpDownResponse__results {
      p {
        padding: 0;
      }
    }
  }
}
</style>